import React, {useState} from 'react'
import {AudioTabContent} from './AudioTabContent'
import {ControlsTabContent} from './ControlsTabContent'
import {DisplayTabContent} from './DisplayTabContent'
import {GameInfoTabContent} from './GameInfoTabContent'
import clsx from 'clsx'
import styles from './UIGameSettings.module.scss'
// eslint-disable-next-line no-restricted-imports
import {UIGameManager} from '../../../../../code/client/shared/scripts/ui_game/UIGameManager'
import UIGameSettingsProvider, {useUIGameSettingsContext} from '../../contexts/UIGameSettingsContext'
import {GameSettings} from '@colonist/game-base-types'
import {TranslationObject} from '@colonist/i18n'
import {T, t} from '../../common/T'

export const UIGameSettingsComponent = () => {
    const SETTING_TABS: {
        id: string
        label: TranslationObject
        icon: string
    }[] = [
        {
            id: 'game-info',
            label: {key: 'strings:game.settings.gameInfoTab.title'},
            icon: '/dist/images/icon_info.svg',
        },
        {
            id: 'display',
            label: {key: 'strings:game.settings.displayTab.title'},
            icon: '/dist/images/icon_display.svg',
        },
        {
            id: 'audio',
            label: {key: 'strings:game.settings.audioTab.title'},
            icon: '/dist/images/icon_audio.svg',
        },
        {
            id: 'controls',
            label: {key: 'strings:game.settings.controlsTab.title'},
            icon: '/dist/images/icon_controls.svg',
        },
    ]

    const {closeSettings} = useUIGameSettingsContext()
    const [activeTab, setActiveTab] = useState(SETTING_TABS[0].id)

    return <div className={styles.gameSettingsContainer}>
        <div className={styles.headingContainer}>
            <img
                alt="Back"
                className={styles.backButton}
                onClick={closeSettings}
                src="/dist/images/icon_arrow.svg"
            />
            <h1 className={styles.heading}><T id='strings:game.settings.title' /></h1>
        </div>
        <div className={styles.contentContainer}>
            <div className={styles.contentLeft}>
                {SETTING_TABS.map((tab) => <div
                    className={clsx(styles.tabButton,
                        tab.id === activeTab && styles.active)}
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}>
                    <img alt={t(tab.label.key, tab.label.options)} className={styles.icon} src={tab.icon}/>
                    <T id={tab.label} />
                </div>)}
            </div>
            <div className={styles.contentRight}>
                {activeTab === 'game-info' && <GameInfoTabContent />}
                {activeTab === 'display' && <DisplayTabContent />}
                {activeTab === 'audio' && <AudioTabContent />}
                {activeTab === 'controls' && <ControlsTabContent />}
            </div>
        </div>
    </div>
}

export const UIGameSettings = ({
    gameManager,
    gameSettings,
}: {
    gameManager: UIGameManager
    gameSettings: GameSettings
}) => <UIGameSettingsProvider gameManager={gameManager} gameSettings={gameSettings}>
    <UIGameSettingsComponent />
</UIGameSettingsProvider>
